
import {defineComponent, onMounted, ref} from 'vue';

// hide header when project tabs are sticky
export default defineComponent({
    setup() {
        const rootEl = ref<HTMLElement | null>(null);

        onMounted(() => {
            if (!rootEl) {
                return;
            }

            const observer = new IntersectionObserver(([e]) => {
                document.body.classList.toggle('project-tabs-intersecting', e.isIntersecting);
            });

            observer.observe(rootEl.value as HTMLElement);
        });

        return {
            rootEl,
        }
    },
})
